import type { ComputedRef } from 'vue'
import type { CustomerBrand } from '@shared/config'
import type { CustomerLabels } from '@entities/customer'

import { Status as CustomerStatus } from '@brighterly/lib-core-types/customer/enums'

import { useCustomerStore } from '@entities/customer'
import { useListsStore } from '@shared/model'

/** Shown when the latest subscription has no agent. */
const DEFAULT_DEAL_OWNER = 'PAD'

interface CustomerLabelsReturn {
  refBrand: ComputedRef<CustomerBrand | null>
  isGo: ComputedRef<boolean>
  refLabels: ComputedRef<CustomerLabels | null>
  isDeal: ComputedRef<boolean>
  refDealText: ComputedRef<string>
  refDealOwner: ComputedRef<string>
}

export const useCustomerLabels = (): CustomerLabelsReturn => {
  const customerStore = useCustomerStore()
  const listsStore = useListsStore()

  const refBrand = computed<CustomerBrand | null>(() => (customerStore.getDetails?.brand ?? null) as CustomerBrand | null)
  const isGo = computed<boolean>(() => !!customerStore.getDetails?.is_go)
  const refLabels = computed<CustomerLabels | null>(() => customerStore.getDetails?.labels ?? null)
  const isDeal = computed<boolean>(() => customerStore.getDetails?.status === CustomerStatus.Deal)
  const refDealText = computed<string>(() => listsStore.getLists?.customer?.status?.[CustomerStatus.Deal] ?? 'Deal')
  const refDealOwner = computed<string>(() =>
    `Deal owner: ${customerStore.getDetails?.deal_owner?.name ?? DEFAULT_DEAL_OWNER}`)

  return {
    refBrand,
    isGo,
    refLabels,
    isDeal,
    refDealText,
    refDealOwner,
  }
}
